import type { SVGProps } from 'react';
import * as React from 'react';

const MsgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/msg">
      <g id="Vector" filter="url(#filter0_dd_3816_37909)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_37909)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2222 7.44444C26.2222 8.9172 27.4161 10.1111 28.8888 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="#F3F4F6"
        />
      </g>
      <path
        id="Vector_2"
        d="M23.083 23.9856L29.4093 27.9811V19.8289L23.083 23.9856ZM22.0197 24.6945L20.3549 25.79C20.2582 25.8545 20.1508 25.8867 20.0327 25.8867C19.9253 25.8867 19.8071 25.8545 19.7105 25.79L18.0564 24.6945L10.699 29.3452C10.7956 29.9037 11.2575 30.3333 11.8375 30.3333H28.2386C28.8186 30.3333 29.2805 29.9037 29.3664 29.3452L22.0197 24.6945ZM28.2386 17.4445H11.8375C11.2467 17.4445 10.7849 17.8848 10.699 18.4433L20.0327 24.5978L29.3664 18.4433C29.2805 17.8848 28.8186 17.4445 28.2386 17.4445ZM10.6667 19.8289V27.9811L16.9823 23.9856L10.6667 19.8289Z"
        fill="#374151"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_37909"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_37909" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_37909" result="effect2_dropShadow_3816_37909" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_37909" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_37909"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.03} />
      </radialGradient>
    </defs>
  </svg>
);
export default MsgIcon;
